/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiWebhookTrigger } from './ApiWebhookTrigger';
import {
    ApiWebhookTriggerFromJSON,
    ApiWebhookTriggerFromJSONTyped,
    ApiWebhookTriggerToJSON,
    ApiWebhookTriggerToJSONTyped,
} from './ApiWebhookTrigger';

/**
 * a Webhook
 * @export
 * @interface ApiWebhook
 */
export interface ApiWebhook {
    /**
     * Unique webhook ID
     * @type {number}
     * @memberof ApiWebhook
     */
    id: number;
    /**
     * 
     * @type {ApiWebhookTrigger}
     * @memberof ApiWebhook
     */
    trigger: ApiWebhookTrigger;
    /**
     * Destination URL
     * @type {string}
     * @memberof ApiWebhook
     */
    url: string;
    /**
     * Authentication token. Will be sent with each webhook requests "X-Salv-Token" header if set.
     * @type {string}
     * @memberof ApiWebhook
     */
    token?: string;
    /**
     * 
     * @type {Date}
     * @memberof ApiWebhook
     */
    createdTime?: Date;
}



/**
 * Check if a given object implements the ApiWebhook interface.
 */
export function instanceOfApiWebhook(value: object): value is ApiWebhook {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('trigger' in value) || value['trigger'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function ApiWebhookFromJSON(json: any): ApiWebhook {
    return ApiWebhookFromJSONTyped(json, false);
}

export function ApiWebhookFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiWebhook {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'trigger': ApiWebhookTriggerFromJSON(json['trigger']),
        'url': json['url'],
        'token': json['token'] == null ? undefined : json['token'],
        'createdTime': json['createdTime'] == null ? undefined : (new Date(json['createdTime'])),
    };
}

export function ApiWebhookToJSON(json: any): ApiWebhook {
    return ApiWebhookToJSONTyped(json, false);
}

export function ApiWebhookToJSONTyped(value?: ApiWebhook | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'trigger': ApiWebhookTriggerToJSON(value['trigger']),
        'url': value['url'],
        'token': value['token'],
        'createdTime': value['createdTime'] == null ? value['createdTime'] : value['createdTime'].toISOString(),
    };
}

